module.exports = __webpack_public_path__ + "static/media/index_bg.ee617e17.jpg";